export default __webpack_public_path__ + "static/media/Sixteen.7af14b3e.svg";